<button
  [attr.aria-label]="'tooltip.userArea' | translate"
  class="user-button"
  [opac-menu-trigger]="isUserAuthenticated ? loggedMenu : guestMenuMobile"
  [opacPopoverTriggerMaxHeight]="999999"
  [opacPopoverTriggerMinWidth]="280"
  [opacTooltip]="'tooltip.userArea' | translate"
  dataTestId="header-user-button"
>
  <span class="menu-icon">
    <opac-icon [badge]="showButtonBadge && (isPendingNotifications || userEventsCount > 0)" icon="menu"></opac-icon>
  </span>

  <opac-avatar
      [picture]="(userAvatar$ | async)?.pictureUrl"
      [style.--background-color]="(userAvatar$ | async)?.color ?? 'transparent'"
  >
    <ng-container *ngIf="isUserAuthenticated">
      {{ ((userAvatar$ | async)?.content) | avatarText }}
    </ng-container>

    <ng-container *ngIf="!isUserAuthenticated">
      <opac-icon icon="account_fill_circle" size="1.5x"></opac-icon>
    </ng-container>
  </opac-avatar>
</button>

<opac-menu #guestMenuMobile>
  <opac-menu-item (click)="handleLogin()">
    {{ 'header.login' | translate }}
  </opac-menu-item>

  <opac-menu-item *ngIf="isUserGuest" (click)="handleLoginGuest()">
    {{ 'header.loginGuest' | translate }}
  </opac-menu-item>

  <opac-menu-item *ngIf="isSignUpAllowed" (click)="handleSignUp()">
    {{ 'header.register' | translate }}
  </opac-menu-item>

  <opac-divider></opac-divider>

  <opac-menu-item *ngIf="helpUrl" (click)="handleHelp()">
    <span>{{ 'header.showHelp' | translate }}</span>
    <opac-icon class="external-icon" icon="external_link"></opac-icon>
  </opac-menu-item>

  <opac-menu-item *ngFor="let button of infoButtons" (click)="handleInfoButton(button)">
    <span>{{ button.textButton }}</span>
    <opac-icon class="external-icon" icon="external_link"></opac-icon>
  </opac-menu-item>
</opac-menu>

<opac-menu #loggedMenu>
  <ng-container *ngIf="isManager()">
    <opac-menu-item class="management-hub-button" (click)="goToManagementHub()">
      <opac-icon icon="admin_panel"></opac-icon>
      <span>{{ 'header.management_hub' | translate }}</span>

      <div class="detail">
        <div class="fake-switch"></div>
      </div>
    </opac-menu-item>

    <opac-divider></opac-divider>
  </ng-container>

  <ng-container *ngFor="let item of userItems">
    <opac-divider *ngIf="item.id === 'details'"></opac-divider>

    <opac-menu-item
      *ngIf="!item.hide"
      [routerLink]="'/user/' + item.id"
      [dataTestId]="'header-user-button-' + item.id"
    >
      <opac-icon
        [badge]="(item.id === 'notifications' && isPendingNotifications) || (item.id === 'events' && userEventsCount > 0)"
        [icon]="item.icon"
      ></opac-icon>

      <span>{{ item.label | translate }}</span>

      <opac-tag *ngIf="item.showNewTag">{{ 'common.new' | translate }}</opac-tag>
    </opac-menu-item>
  </ng-container>

  <opac-divider></opac-divider>

  <ng-container *ngIf="showHelpButtonsInMenu">
    <opac-menu-item *ngIf="helpUrl" (click)="handleHelp()">
      <span>
        {{ 'header.showHelp' | translate }}
        <opac-icon class="external-icon" icon="external_link"></opac-icon>
      </span>
    </opac-menu-item>

    <opac-menu-item *ngFor="let button of infoButtons" (click)="handleInfoButton(button)">
      <span>
        {{ button.textButton }}
        <opac-icon class="external-icon" icon="external_link"></opac-icon>
      </span>
    </opac-menu-item>

    <opac-divider></opac-divider>
  </ng-container>

  <div class="user-info">
    <p>{{ loggedUser?.name }}</p>
    <span>{{ 'header.lastAccess' | translate }}</span>
    <p>{{ loggedUser?.lastLogin | date: 'medium' }}</p>
  </div>

  <opac-divider></opac-divider>

  <opac-menu-item
    routerLink="/logout"
    dataTestId="header-user-button-logout"
  >
    <opac-icon icon="switch_on_off"></opac-icon>
    <span>{{ 'header.logout' | translate }}</span>
  </opac-menu-item>
</opac-menu>
